import { z } from 'zod';

import {
  ESuluCardSliderVariants,
  ESuluContentBlockTypes,
} from 'types/enums/sulu/EBackendData';

import ZSCBBase from './ZSCBBase';
import ZSCBPageCard from './ZSCBPageCard';
import ZSuluMedia from './ZSuluMedia';

/**
 * Mind the IconCard can not (yet) be added as a standalone block.
 * It is currently only part of the SliderSelector schema / block.
 */
const ZIconCard = z.object({
  icon: ZSuluMedia.or(z.null()),
  title: z.string().or(z.null()),
  description_html: z.string().or(z.null()),
  button_link: z.string().or(z.null()),
  open_in_new_tab: z
    .boolean()
    .or(z.null()) // null is default
    .or(z.undefined()),
  button_text: z.string().or(z.null()),
  has_orchid_theme: z.boolean().or(z.undefined()),
});

const ZSCBSliderSelector = ZSCBBase.extend({
  type: z.literal(ESuluContentBlockTypes.SLIDER_SELECTOR),
  title: z.string().or(z.null()),
  variant: z.nativeEnum(ESuluCardSliderVariants).or(z.null()),
  icon_cards: z.array(ZIconCard.extend({ cards: z.array(ZSCBPageCard) })),
  has_orchid_theme: z.boolean().or(z.undefined()),
});

export default ZSCBSliderSelector;
